<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="600px">
      <v-card>
        <v-toolbar elevation="0" color="background">
          <v-toolbar-title class="pl-3 text--subtitle">
            <v-icon color="primary" style="padding-bottom: 2px"
              >mdi-video-plus</v-icon
            >
            {{ $t('message.renameVideo') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="handleClose()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="pl-7 pr-5 py-0">
          <v-container class="pl-0">
            <v-row no-gutters>
              <v-col cols="12">
                <v-form ref="form" v-model="valid" v-on:submit.prevent>
                  <v-text-field
                    v-model="video.title"
                    autofocus
                    outlined
                    dense
                    :label="$t('message.name')"
                    :rules="[rules.required, rules.maxLength, rules.minLength]"
                    required
                    counter="255"
                    color="primary"
                    @keyup.enter="handleEnter"
                  ></v-text-field>
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="px-8 pb-6">
          <v-spacer></v-spacer>
          <v-btn
            text
            class="mr-4 px-4"
            :disabled="isFetching"
            @click="handleClose"
          >
            {{ $t('message.cancel') }}
          </v-btn>
          <v-btn
            large
            class="primary white--text"
            min-width="185px"
            @click="handleEdit"
            :loading="isFetching"
            :disabled="!valid || isFetching"
          >
            {{ $t('message.confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import i18n from '@/translations/lang'
import videosApi from '../services/videosApi'

export default {
  name: 'VideoModalRename',
  components: {},
  data: () => ({
    open: null,
    isFetching: false,
    video: {
      name: '',
    },
    edit: false,
    videoId: '',
    valid: false,
    rules: {
      required: (v) => (v && !!v) || i18n.t('message.requiredField'),
      maxLength: (v) =>
        (v && v.length <= 255) || i18n.t('message.maximumLength'),
      minLength: (v) => (v && v.length > 2) || i18n.t('message.minimumLength'),
    },
  }),
  watch: {
    open(val) {
      const refForm = this.$refs.form
      refForm && refForm.resetValidation()
      if (val === false) this.$root.$emit('VideoModalRenameHasClosed')
    },
  },
  mounted() {
    this.$root.$on('videoModalRename', (video) => {
      this.$root.$emit('renameModalOpened')
      this.video = video
      this.edit = video.edit
      this.videoId = video.id
      this.open = true
    })
  },
  beforeDestroy() {
    this.$root.$off('videoModalRename')
    this.$root.$emit('resetIsAnyOtherModal')
    this.$root.$emit('renameModalClosed')
  },
  methods: {
    ...mapActions('video', ['getVideoConfig', 'getVideoProfileId']),
    ...mapMutations('video', [
      'UPDATE_VIDEO',
      'UPDATE_VIDEO_PROFILE',
      'UPDATE_PLAYER',
      'UPDATE_VIDEO_PROFILE_ID',
    ]),
    async handleEdit() {
      this.isFetching = true
      try {
        let ret = await videosApi.updateVideo(
          { title: this.video.title.trim() },
          this.video.id
        )
        this.UPDATE_VIDEO(this.video)
        this.UPDATE_VIDEO_PROFILE({
          open: true,
          text: `Video ${ret.data.title} renomeado`,
        })
        this.$root.$emit('updateVideoVideosPage', ret.data)
      } catch (e) {
        this.UPDATE_VIDEO_PROFILE({
          open: true,
          text: `${e}`,
        })
      }
      this.isFetching = false
      this.handleClose()
    },
    handleClose() {
      this.open = null
      this.$root.$emit('renameModalClosed')
    },
    handleEnter() {
      if (this.valid) {
        this.handleEdit()
      }
    },
  },
}
</script>

<style>
.cardTitle {
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
}
</style>
